module.exports = "data:image/svg+xml;base64,PHN2Zz4KICA8ZGVmcz4KICAgIDxzeW1ib2wgaWQ9Im5vbmUiIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIj4KICAgICAgPGRlc2M+bm9uZTwvZGVzYz4KICAgICAgPHJlY3QgaWQ9Im5vbmUiIHg9IjAiIHk9IjAiIHdpZHRoPSIwIiBoZWlnaHQ9IjAiCglzdHJva2U9Im5vbmUiIGZpbGw9Im5vbmUiIHN0cm9rZS13aWR0aD0iMCIvPgogICAgPC9zeW1ib2w+CiAgPC9kZWZzPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/icons/none.svg
// module id = 704
// module chunks = 0